function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon feather-arrow-right",
  className: "arrowRight_svg__stroke",
  fill: "none",
  stroke: "#444",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 11",
  d: "M.5 6.026h10.638"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M5.819.707l5.319 5.319-5.319 5.319"
}));

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.638,
    height: 12.052,
    viewBox: "0 0 11.638 12.052"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS42MzgiIGhlaWdodD0iMTIuMDUyIiB2aWV3Qm94PSIwIDAgMTEuNjM4IDEyLjA1MiI+CiAgPGcgaWQ9Ikljb25fZmVhdGhlci1hcnJvdy1yaWdodCIgZGF0YS1uYW1lPSJJY29uIGZlYXRoZXItYXJyb3ctcmlnaHQiIGNsYXNzPSJzdHJva2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03IC02Ljc5MykiPgogICAgPHBhdGggaWQ9IlBhdGhfMTEiIGRhdGEtbmFtZT0iUGF0aCAxMSIgZD0iTTcuNSwxOEgxOC4xMzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTUuMTgxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNDQ0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTIiIGRhdGEtbmFtZT0iUGF0aCAxMiIgZD0iTTE4LDcuNWw1LjMxOSw1LjMxOUwxOCwxOC4xMzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01LjE4MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzQ0NCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgArrowRight as ReactComponent };